import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueResource from "vue-resource";
Vue.use(VueResource);

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);

import VueGoogleCharts from 'vue-google-charts'; 
Vue.use(VueGoogleCharts);

const eventsHub = new Vue();
import IdleVue from "idle-vue";
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 300000 //5 minutes = 300000
});

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from "@fortawesome/vue-fontawesome";
library.add(fas);
library.add(fab);
library.add(far);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);

import VueScrollReveal from 'vue-scroll-reveal';
Vue.use(VueScrollReveal);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  onIdle() {
    this.messageStr = "idle";
  },
  onActive() {
    this.messageStr = "active";
  },
  render: h => h(App)
}).$mount('#app')
